import { render, staticRenderFns } from "./declareUpload.vue?vue&type=template&id=51550096&scoped=true"
import script from "./declareUpload.vue?vue&type=script&lang=js"
export * from "./declareUpload.vue?vue&type=script&lang=js"
import style0 from "./declareUpload.vue?vue&type=style&index=0&id=51550096&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51550096",
  null
  
)

export default component.exports